export class ItemType {
  constructor(key, value) {
    this.key = key;
    this.value = value;
  }
  key: any;
  value: any;
}
